<form [formGroup]="form" (ngSubmit)="onSubmit()" class="grid gap-4">
  <div class="grid gap-4 sm:grid-cols-2">
    <et-atoms-input class="w-full sm:col-span-2">
      <label>Notary name</label>
      <input etAtomsInput formControlName="notaryName" type="text" required />
      @if (form.controls['notaryName'].touched &&
      form.controls['notaryName'].invalid) {
      <span etAtomsInputError>Notary name is required</span>
      }
    </et-atoms-input>

    <et-atoms-select-field class="w-full sm:col-span-2">
      <label>State</label>
      <et-atoms-select-input formControlName="state" required>
        @for (option of stateOptions; track option.name) {
        <et-atoms-select-option [value]="option.name">{{
          option.name
        }}</et-atoms-select-option>
        }
      </et-atoms-select-input>
      @if (form.controls['state'].touched && form.controls['state'].invalid) {
      <span etAtomsSelectError>State is required</span>
      }
    </et-atoms-select-field>

    <et-atoms-input class="w-full sm:col-span-2">
      <label>Default fee per document</label>
      <input
        etAtomsInput
        interfaceCurrencyFormatter
        [maximumFractionDigits]="2"
        formControlName="feeCharged"
      />
      @if (form.controls['feeCharged'].touched &&
      form.controls['feeCharged'].invalid) {
      <span etAtomsInputError>Enter a valid fee</span>
      }
    </et-atoms-input>
  </div>

  <!-- Error message -->
  @if(error) {
  <p class="text-error">{{ error }}</p>
  } @if (!hideButtons) {
  <div class="flex flex-wrap justify-end gap-4">
    <button
      type="button"
      class="normal-case rounded-full btn btn-outline min-w-[184px] text-base"
      mat-dialog-close
      [disabled]="isLoading"
    >
      Cancel
    </button>
    <button
      type="submit"
      class="normal-case rounded-full btn btn-primary min-w-[184px] text-base"
      [class.pointer-events-none]="isLoading"
    >
      @if (isLoading) {
      <et-atoms-spinner size="small"></et-atoms-spinner>
      } @else { Save }
    </button>
  </div>
  }
</form>
